module.exports = __webpack_public_path__ + "img/caviar.05e17cda.png";